import { render, staticRenderFns } from "./WithdrawDefaultForm.vue?vue&type=template&id=9f6ba8c4&scoped=true"
import script from "./WithdrawDefaultForm.vue?vue&type=script&lang=js"
export * from "./WithdrawDefaultForm.vue?vue&type=script&lang=js"
import style0 from "./WithdrawDefaultForm.vue?vue&type=style&index=0&id=9f6ba8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6ba8c4",
  null
  
)

export default component.exports